import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { Col, Form, Row, Button, Card } from "react-bootstrap";

//
import { Formik } from "formik";
import * as yup from "yup";

//
import UploadAvatar from "./UploadAvatar";
import BoxLoading from "../../general/BoxLoading";

//
import { updateProfile } from "../../../redux/features/user/actions";
import { setUser } from "../../../redux/features/user/slice";

//
const schema = yup.object().shape({
  username: yup.string().required(),
  first_name: yup.string().required(),
  last_name: yup.string().required(),
});

function UserInfo({ user, setUser }) {
  const [loading, setLoading] = useState(false);

  let initialValues = {
    username: user.username || "",
    first_name: user.first_name || "",
    last_name: user.last_name || "",
  };

  /**
   * Update User Profile
   */
  const update_profile = async (e) => {
    // start loading
    setLoading(true);

    // request
    await updateProfile(e).then(res => {
      if (res) {
        setUser(res);
      }
    });

    // stop loading
    setLoading(false);
  };

  return (
    <Col md={7} xl={8} className="gutter-b">
      <Card className="user-info bordered h-100">
        <Card.Body className="d-flex flex-column justify-content-between">
          <div>
            <div className="title">
              <h5>Profile Data</h5>
              <p className="subject">
                Feel free to edit your basic information such as photo, username
                & email,
              </p>
            </div>

            <UploadAvatar />
          </div>

          <Formik
            validationSchema={schema}
            onSubmit={update_profile}
            initialValues={initialValues}
          >
            {({ handleSubmit, handleChange, values, touched, errors }) => (
              <Form noValidate onSubmit={handleSubmit}>
                {/* Username */}
                <Row>
                  <Col md={6}>
                    <Form.Group
                      className="form-group"
                      controlId="validationFormik0"
                    >
                      <Form.Label>Username</Form.Label>
                      <Form.Control
                        type="text"
                        name="username"
                        placeholder="Username"
                        className="form-control"
                        onChange={handleChange}
                        autoComplete="off"
                        value={values.username}
                        isInvalid={touched.username && !!errors.username}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  {/* First Name */}
                  <Col md={6}>
                    <Form.Group
                      className="form-group"
                      controlId="validationFormik1"
                    >
                      <Form.Label>First name</Form.Label>
                      <Form.Control
                        type="text"
                        name="first_name"
                        placeholder="First name"
                        className="form-control"
                        onChange={handleChange}
                        autoComplete="off"
                        value={values.first_name}
                        isInvalid={touched.first_name && !!errors.first_name}
                      />
                    </Form.Group>
                  </Col>

                  {/* Last Name */}
                  <Col md={6}>
                    <Form.Group
                      className="form-group"
                      controlId="validationFormik2"
                    >
                      <Form.Label>Last name</Form.Label>
                      <Form.Control
                        type="text"
                        name="last_name"
                        placeholder="Last name"
                        className="form-control"
                        onChange={handleChange}
                        autoComplete="off"
                        value={values.last_name}
                        isInvalid={touched.last_name && !!errors.last_name}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Button type="submit" variant="info" size="lg" hidden>
                  Submit
                </Button>
              </Form>
            )}
          </Formik>
        </Card.Body>

        {loading && <BoxLoading />}
      </Card>
    </Col>
  );
}

const mapDispatchToProps = {
  setUser,
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
});

UserInfo.propTypes = {
  user: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);
